exports.components = {
  "component---src-pages-404-js": () => import("./../../../src/pages/404.js" /* webpackChunkName: "component---src-pages-404-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-templates-class-template-js": () => import("./../../../src/templates/ClassTemplate.js" /* webpackChunkName: "component---src-templates-class-template-js" */),
  "component---src-templates-teacher-template-js": () => import("./../../../src/templates/TeacherTemplate.js" /* webpackChunkName: "component---src-templates-teacher-template-js" */)
}

